module.exports = __webpack_public_path__ + "assets/img/collect-cards-dark3.afeeeaf8.png";